import React, { useEffect, useState } from "react";
import axios from "axios";
import { Hammer, Globe } from "lucide-react";
import { toast } from "sonner";
import { API } from "../../lib/store";
import { Button } from "../ui/button";

export function MaintenanceToggle({ auth }) {
  const [on, setOn] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-status`)
      .then((r) => setOn(Boolean(r.data.maintenance)))
      .catch((e) => console.warn("Site status fetch failed:", e?.message));
  }, []);

  const toggle = async () => {
    const next = !on;
    const msg = next
      ? "Put the site into UNDER CONSTRUCTION mode?\n\nVisitors will see a branded 'coming soon' page with your phone & WhatsApp. The admin dashboard stays accessible to you."
      : "Bring the site back ONLINE for all visitors?";
    if (!window.confirm(msg)) return;
    try {
      await axios.post(`${API}/admin/maintenance`, { enabled: next }, auth);
      setOn(next);
      toast.success(next ? "Site is now Under Construction" : "Site is live again");
    } catch {
      toast.error("Could not update site mode");
    }
  };

  if (on === null) return null;
  return (
    <Button
      variant="outline"
      onClick={toggle}
      className={`rounded-none ${on ? "border-[#8c2f1b] text-[#8c2f1b] hover:bg-[#8c2f1b] hover:text-white" : "border-[#d8cdb5]"}`}
      data-testid="admin-maintenance-toggle"
      title={on ? "Click to bring the site back online" : "Click to show an Under Construction page to visitors"}
    >
      {on ? (
        <><Hammer size={15} className="mr-2" /> Under Construction — click to go live</>
      ) : (
        <><Globe size={15} className="mr-2 text-[#3f6b3a]" /> Site Live</>
      )}
    </Button>
  );
}
